<template>
	<div class="container">
		<div class="Evaluate_input">
			<div class="file_container">
				<textarea @input="file_change" v-model="file_text" class="file_text" name="file_text" rows="" maxlength="300" cols="" placeholder="请输入观后感"></textarea>
			</div>
			<div class="file_num"><span>{{file_num}}</span>/300</div>
		</div>
		<div class="inp_file">
			<div v-for="(item,index) in license" class="file">
				<div class="file_img">
					<img :src="item.imageurl" />
				</div>
				<div class="file_no" @click="Delete(item,index)">
					<img src="../assets/file_no.png" />
				</div>
			</div>
			<div class="file">
				<div class="file_img">
					<img src="../assets/file_one.png" />
				</div>
				<form id="uploadForm" enctype="multipart/form-data">
					<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile()" />
					<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
				</form>
			</div>
		</div>
		<div class="Submission">
			<div class="file_btn" @click="Submission" v-show="showBtn">提交</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'ReadingFile',
		data() {
			return {
				file_num: 0,
				fill_img: "",
				file_text: "",
				success: false,
				success_img: false,
				success_text: "",
				license: [],
				baseUrlOne: "",
				baseUrl: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true
			}
		},
		methods: {
			Delete(item, index) {
				var that = this;
				that.license.splice(index, 1)
			},
			file_change() {
				var that = this;
				that.file_num = that.file_text.length;
				if(that.file_text.length >= 300) {
					that.file_num = 300;
					that.file_text = that.file_text;
				}
			},
			uploadFile() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrlOne + '/account/upload/image/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.imageurl.length == 1) {
							that.fill_img = data.imageurl[0].imageurl;
							if(that.license.length > 4) {
								that.success = true;
								that.success_img = false;
								that.success_text = '图片最多上传五张';
							} else {
								that.license.push({
									"imageid": "cd68da094293489b8e9785af87689681",
									"imageurl": that.fill_img
								});
							}
						} else {
							if(data.imageurl.length > 4) {
								that.success = true;
								that.success_img = false;
								that.success_text = '图片最多上传五张';
							} else {
								that.license = data.imageurl;
							}
						}
					} else {
						that.success = true;
						that.success_img = false;
						that.success_text = '请上传jpg,jpeg,png格式的图片';
					}

				}).fail(function(res) {});
			},
			Submission() {
				var that = this;
				if(that.file_text == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请填写观后感'
				} else {
					wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "GET",
						url: that.baseUrl + '/tickets/tickets/ajax?ugi=userTicket&action=userCommontOrder&moduleid=TICKETS&orderid=' + that.orderid,
						dataType: "json",
						async: true,
						data: {
							content: that.file_text,
							url: JSON.stringify(that.license)
						},
						success: function(data) {
							wclient.view.hideLoading();
							if(data.code = 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '提交成功'
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg;
							}
						}
					});
				}
			},
			determine() {
				var that = this;
				if(that.success_text == "提交成功") {
					that.$router.go(-1)
				} else {
					that.success = false;
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "http://xs.weapi.org";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			that.orderid = sessionStorage.getItem("read_orderid");
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		background: white;
	}
	
	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.file_btn {
		width: 70%;
		margin: 10px auto;
		line-height: 40px;
		background: rgba(215, 43, 39, 1);
		border-radius: 62px;
		text-align: center;
		font-size: 16px;
		color: rgba(254, 254, 254, 1);
	}
	
	.Submission {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		background: white;
	}
	
	.inp_file {
		width: 90%;
		margin: 0 5%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 70px;
	}
	
	.file {
		position: relative;
		width: 30%;
		height: 100px;
		margin-top: 10px;
		margin-right: 9px;
	}
	
	.file_img {
		float: left;
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}
	
	.file input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	.file_no {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		box-shadow: 0px 1px 7px 2px rgba(154, 154, 154, 0.2);
		color: #9A9A9A;
		background: rgb(252, 245, 247);
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 100%;
		color: black;
		font-size: 20px;
		font-weight: 600;
		text-align: center;
		margin-top: 20px;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.Evaluate_input {
		width: 90%;
		border-bottom: 1px solid #DBDBDB;
		margin: 10px auto 0;
		line-height: 60px;
		font-size: 16px;
	}
	
	.file_container {
		width: 100%;
		position: relative;
	}
	
	.file_text {
		display: block;
		width: 90%;
		height: 240px;
		background: #F6F6F6;
		outline: none;
		padding: 20px 5% 0;
		font-size: 14px;
		overflow: hidden;
		border-radius: 4px;
		resize: none;
		line-height: 20px;
		border: none;
		overflow-y: scroll;
	}
	
	.file_num {
		color: rgba(180, 180, 180, 1);
		width: 90%;
		text-align: right;
		line-height: 45px;
		padding: 0 5%;
		background: #F6F6F6;
	}
</style>


// WEBPACK FOOTER //
// src/components/readingFile.vue